export enum ContainerFillMethodEnum {
   Volume = 0,
   Unit = 1,
   ProductPalletQuantity = 2
}